import { NgModule } from '@angular/core';

import { AnalysisRoutingModule } from './analysis-routing.module';
import { AnalysisInformationComponent } from './components/analysis-information/analysis-information.component';
import { SharedModule } from '../../shared/shared.module';
import { TrainsModule } from '../trains/trains.module';
@NgModule({
  declarations: [AnalysisInformationComponent],
  imports: [
  SharedModule,
    AnalysisRoutingModule,
    TrainsModule
  ]
})
export class AnalysisModule { }
